export default __webpack_public_path__ + "static/media/grocery15.78fd8197.jpeg";